var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetListProfessionalOrganizationUnitSubscribe, apiDeleteProfessionalOrganizationUnitSubscribeMany, } from '../../../../actions/FavoriteActions';
import { wrapDispatch } from '../../../../helpers/action';
import { useDidMount, usePromiseDoingCallback, useUnmountRef, } from '../../../../helpers/use/useHook';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import { CurrentProcessLoader } from '../../../Ui/Loading';
import MySubscribeProfessionalUnitsCardList from './MySubscribeProfessionalUnitsCardList';
const MySubscribeProfessionalUnits = () => {
    const [checks, changeChecks] = useState([]);
    const [list, changeList] = useState([]);
    const [isHasMore, changeIsHasMore] = useState(false);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    /**
     * 初期読み込み
     * @type {(function(): Promise<void>)|*}
     */
    const rawLoadInitialData = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield wrapDispatch(dispatch, apiGetListProfessionalOrganizationUnitSubscribe());
        const { payload: { list: resList }, total, } = res;
        if (!unmountRef.current) {
            changeList(resList);
            changeIsHasMore(total > resList.length);
        }
    }), [changeList, changeIsHasMore, dispatch, unmountRef]);
    const [loadInitialData, isLoading] = usePromiseDoingCallback(rawLoadInitialData, unmountRef);
    /**
     * チェック状態の切り替え
     * @type {(function(*): void)|*}
     */
    const onChange = useCallback((e) => {
        const { checked, value } = e.currentTarget;
        const id = parseInt(value, 10);
        changeChecks((prevState) => checked ? [...prevState, id] : prevState.filter((v) => v !== id));
    }, [changeChecks]);
    /**
     * 選択中のデータをまとめて削除
     * @type {(function(): Promise<void>)|*}
     */
    const rawOnClickDelete = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiDeleteProfessionalOrganizationUnitSubscribeMany(checks));
        if (!unmountRef.current) {
            changeChecks([]);
            changeList(list.filter((v) => !checks.includes(v.id)));
        }
    }), [changeChecks, changeList, checks, dispatch, list, unmountRef]);
    const [onClickDelete, isDeleting] = usePromiseDoingCallback(rawOnClickDelete, unmountRef);
    /**
     * 続きの読み込み
     * @type {(function(): Promise<void>)|*}
     */
    const rawOnClickMore = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { id } = list[list.length - 1];
        const res = yield wrapDispatch(dispatch, apiGetListProfessionalOrganizationUnitSubscribe({
            less_than: id,
        }));
        const { payload: { list: getList }, total, } = res;
        const updateList = _.uniqBy([...list, ...getList], (row) => row.id);
        if (!unmountRef.current) {
            changeList(updateList);
            changeIsHasMore(total > updateList.length);
        }
    }), [list, dispatch, unmountRef, changeList, changeIsHasMore]);
    const [onClickMore, isMoreLoading] = usePromiseDoingCallback(rawOnClickMore, unmountRef);
    useDidMount(() => {
        loadInitialData().then();
    });
    return (_jsx("div", Object.assign({ className: 'l-container-12' }, { children: _jsxs("div", Object.assign({ className: 'content-box' }, { children: [_jsx("h3", { children: "\u304A\u6C17\u306B\u5165\u308A\u30D5\u30A1\u30FC\u30E0" }), _jsx("div", Object.assign({ className: 'favorite-select' }, { children: _jsx("div", Object.assign({ className: 'favorite-select-inner' }, { children: _jsx(SubmitButton, { buttonType: 'button', className: 'link-text select-delete', isDisabled: isDeleting || checks.length === 0, isLoading: isDeleting, onClick: onClickDelete, text: _jsxs(_Fragment, { children: [_jsx("i", Object.assign({ className: 'material-icons hov-icon md-18' }, { children: "delete" })), "\u304A\u6C17\u306B\u5165\u308A\u304B\u3089\u524A\u9664"] }) }) })) })), _jsx("div", Object.assign({ className: 'l-subscribe-unit is-flex' }, { children: isLoading ? (_jsx(CurrentProcessLoader, { marginTop: 30 })) : (_jsx(MySubscribeProfessionalUnitsCardList, { list: list, onChange: onChange })) })), isHasMore && (_jsx("div", Object.assign({ className: 'align-center l-bottom mt2' }, { children: _jsx(SubmitButton, { isDisabled: isMoreLoading, isLoading: isMoreLoading, onClick: onClickMore, text: 'View More' }) })))] })) })));
};
export default MySubscribeProfessionalUnits;
